import { render, staticRenderFns } from "./NhNewsCard.vue?vue&type=template&id=1013e5e4&scoped=true"
import script from "./NhNewsCard.vue?vue&type=script&lang=js"
export * from "./NhNewsCard.vue?vue&type=script&lang=js"
import style0 from "./NhNewsCard.vue?vue&type=style&index=0&id=1013e5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013e5e4",
  null
  
)

export default component.exports